import type { ComponentProps } from 'react'
import FollowUp from '../../shared/FollowUp'

type Props = ComponentProps<typeof FollowUp>

export default function Step9_FollowUp(props: Props) {
  return <FollowUp {...props} />
}

